import Tone from 'tone';
import {NO_SUB_SEQUENCE} from './constants.js';

class AbstractMix {
    constructor(sequencerEngine, subSequence) {
        this.sequencerEngine = sequencerEngine;
        this.subSequence =
            subSequence === undefined ?
            NO_SUB_SEQUENCE :
            subSequence;
    }

    getTimeForEventToAdd(event) {
        if (!this.sequencerEngine.playing) {
            return undefined;
        }

       let time =
            new Tone.Time(Tone.Master.currentTime).toMilliseconds() -
            new Tone.Time(this.sequencerEngine.automationTime).toMilliseconds();

        let step = this.sequencerEngine.automationStep || 0;
        if (event.isDeterministic()) {
        } else {
            step--;
        }

        return {
            time: time,
            step: step,
        };
    }

    seekToTrackStep(trackStep) {}

    resizeEvent(event, newSize, inPlace) {}
    
    deleteEvent(event, inPlace) {}

    deleteCompoundEvent(event, subEvent) {}

    insertEvent(event, duration) {}

    pasteEvents(events, position) {}

    restart() {}

    addEvent(event) {}

    holdEvent(event) {}
    
    scheduleNext(trackStep, time) {}
    
    schedule() {}

    getValue(type, step) {}

    getEvent(type, step) {}
}

export default AbstractMix;
